/*
 * @Author: Gaho
 * @Date: 2023-12-29 14:36:37
 * @LastEditors: Gaho
 * @LastEditTime: 2023-12-29 14:41:18
 */
const s = {
    ballDistance: 20.4,
    diameter: 10.54,
    numRows: 13,
    ballProp: {
        mass: 1.1,
        densety: .9,
        friction: {
            x: .97,
            y: .93
        }
    },
    xps: {
        0: [325.91580486519626, 325.9313149712557, 326.58682716763013, 327.3243680475434],
        1: [356.8558288022159, 354.99440092537054, 326.592456425573, 326.43333382053504, 327.0730929730993, 325.07167452663936, 324.25571594964947, 326.4733776528344],
        2: [327.06671221505775, 324.10448219111686, 325.06891562703714, 325.92905631760595, 324.2294751089768, 325.1054873216233, 356.8712077696745, 324.53677746966844],
        3: [326.9760485091849, 355.38225521808073, 354.788931000935, 326.87394912564963, 357.5810553190788, 326.2667333743293, 327.1862877484182, 324.5592896273304],
        4: [356.7713137282928, 326.4013848121269, 324.54502002836637, 326.2157253875686, 356.8852696766762, 356.0228107328488, 355.3930970998064, 325.0796656617689],
        5: [323.84030851815095, 354.94540034515444, 354.9431223379703, 357.44376045804995, 357.55480476075263, 356.03921707235565, 356.001529536387, 355.3605467970595],
        6: [357.70973488310494, 324.0981953620853, 357.70527858586297, 355.63821512547986, 356.79709292073926, 326.36064910775593, 357.8621327368393, 324.0534712110654],
        7: [324.3994828370739, 358.17454690980946, 327.2143322081307, 355.1898168210763, 324.0725279865292, 358.2403408366882, 358.1740380929919, 325.62129589005417],
        8: [323.9940508888769, 357.7297577555371, 355.4536105993465, 324.4681059125318, 357.51555000063706, 357.7950653162561, 355.8150320141317, 327.12683471322714],
        9: [354.9343794429613, 357.6381227010023, 357.6195246180066, 356.99108908402235, 356.158693303634, 355.7384474626205, 356.93524813409454, 356.20285627735836],
        10: [356.0729773338345, 357.66235297237785, 325.9712803149075, 358.18017950718274, 355.1406735960056, 358.04869164916784, 357.6916055326326, 357.99662014822337],
        11: [324.4782012730525, 326.3694934875145, 324.1022196122946, 355.09550184176493, 325.9717761912505, 324.4045112601449, 357.49896546529794, 356.08405169320883],
        12: [356.0705762209156, 356.0691125547999, 356.06911206269706, 323.79149785348017, 326.69826110999367, 357.83464682031916, 354.95674010297057, 355.18546234114666],
        13: [324.44726857778033, 355.40931520667925, 355.6284473679611, 356.08576088026706, 355.40348832148345, 356.9276359933494],
        14: []
    }
};
export {s as default};
